import { useParams } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { PeoplePage } from '../components/people/PeoplePage';

/**
 * USER-02 at `/admin/users/$userId`: a notification's, a palette's or an old bookmark's link to one person. It opens
 * People with that person already in the pane beside the list, so the link lands on the person and the list is
 * one glance away (Admin redesign 2026-11-02, People A).
 */
export function UserDetailPage(): ReactNode {
  const { userId } = useParams({ from: '/app-layout/admin/users/$userId' });
  return <PeoplePage routePersonId={userId} />;
}
